import Skeleton from '@mui/material/Skeleton';

export const LandingLoaderCards = () => (
  <div className='-mx-8 xl:-mx-12 flex flex-wrap'>
    {[1, 2, 3, 4, 5, 6, 7, 8].map((index) => (
      <div key={`loader-${index}`} className='px-8 xl:px-12 w-1/4 mb-16 xl:mb-30 min-h-[110px] xl:min-h-[8.4375rem]'>
        <div className='p-12 shadow-[0_4px_7px_0_rgba(0,0,0,0.06)] border-b-2 rounded-8 flex bg-neutral-10 border border-neutral-20 h-full flex-col gap-8'>
          <Skeleton animation='wave' height={18} width='20%' style={{ backgroundColor: '#DFDFDF', borderRadius: '4px' }} />
          <Skeleton animation='wave' height={16} width='90%' style={{ backgroundColor: '#DFDFDF', borderRadius: '4px' }} />

          <div className='mt-auto'>
            <Skeleton animation='wave' height={14} width='60%' style={{ backgroundColor: '#DFDFDF', borderRadius: '4px' }} />
          </div>
        </div>
      </div>
    ))}
  </div>
);
